// @flow
import React from "react"
import withConnect from "hoc/withConnect"
import { hideGDPR } from "data/app/actions"
import { selectGDPRHidden } from "data/app/selectors"
import {
  Wrap,
  Layout,
  StyledText as Text,
  StyledButton as Button,
} from "./styled"

const GDPRWarning = ({ GDPRHidden, hideGDPR }) => !GDPRHidden && (
  <Wrap>
    <Layout>
      <Text>
        We have cookies on our website (also, in our bellies). By using this site, you agree that we may store and access cookies on your device. Cool?
      </Text>
      <Button onClick={hideGDPR}>Cool</Button>
    </Layout>
  </Wrap>
)

const mapStateToProps = state => ({
  GDPRHidden: selectGDPRHidden(state),
})

const mapDispatchToProps = {
  hideGDPR,
}

export default withConnect(
  mapStateToProps,
  mapDispatchToProps,
)(GDPRWarning)



// WEBPACK FOOTER //
// ./src/components/GDPRWarning/index.js